<footer>
    <div class="site-gutter">
        <div class="footer-wrapper">
            <div class="footer-info">
                <a routerLink="/" class="footer-link">
                    <pc-footer-logo></pc-footer-logo>
                </a>
                <div class="footer-navigation">
                    <a routerLink="/about-us">About Us</a>
                    <a routerLink="/services">Services</a>
                    <a routerLink="/projects">Project Gallery</a>
                    <a routerLink="/contact-us">Contact Us</a>
                    <a routerLink="/contact-us" fragment="bid-request">Bid Request</a>
                    <a routerLink="/contact-us" fragment="careers">Careers</a>
                </div>
            </div>

            <div class="business-info">
                <div class="business-section">
                    <p>132 West Broad Street <br>Salunga, PA 17538 United States</p>
                    <p>Monday-Friday: 6:30AM-3:30PM <br>Saturday & Sunday: Closed</p>
                </div>

                <div class="business-section contact">
                    <a href="tel:+17178981723">(717) 898-1723</a>
                    <a href="mailto:info&#64;pchaines.com">info&#64;pchaines.com</a>

                    <div class="social-links">
                        <a href="https://www.facebook.com/pchainesinc/" target="_blank">
                            <pc-facebook-logo></pc-facebook-logo>
                        </a>
                        <a href="https://www.linkedin.com/company/pc-haines-inc-wall-ceiling-contractor/" target="_blank">
                            <pc-linkedin-logo></pc-linkedin-logo>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</footer>